var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{'card-form__container': true, 'card-form--collapsed': !_vm.collapsed}},[(_vm.collapsed)?_c('div',[_vm._t("expanded")],2):_c('div',[_vm._t("collapsed")],2)])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }